import { z } from 'zod'
import { parseWorkoutInput } from './validation'
import type { ActivityType, WorkoutRecord } from './types'

const titles: Record<string, { key: string; label: string; type: ActivityType }> = {
  爬坡: { key: 'incline-walking', label: '爬坡', type: 'walking' },
  力量训练: { key: 'strength', label: '力量训练', type: 'strength' },
  传统力量训练: { key: 'strength', label: '传统力量训练', type: 'strength' },
  混合有氧: { key: 'mixed-cardio', label: '混合有氧', type: 'other' },
  混合有氧训练: { key: 'mixed-cardio', label: '混合有氧', type: 'other' },
  椭圆机: { key: 'elliptical', label: '椭圆机', type: 'other' },
  椭圆机训练: { key: 'elliptical', label: '椭圆机', type: 'other' },
  瑜伽: { key: 'yoga', label: '瑜伽', type: 'yoga' },
  瑜伽训练: { key: 'yoga', label: '瑜伽', type: 'yoga' },
}
export const calendarWorkoutSchema = z.strictObject({
  version: z.literal(1), exportedAt: z.iso.datetime({ offset: true }),
  title: z.string().min(1).max(240), startAt: z.iso.datetime({ offset: true }),
  endAt: z.iso.datetime({ offset: true }), timeZone: z.string().min(1).max(80),
  activeEnergyKcal: z.number().finite().optional(),
})
export type CalendarWorkoutUpload = z.infer<typeof calendarWorkoutSchema>
export function parseCalendarWorkout(input: unknown, now = new Date()): { upload: CalendarWorkoutUpload; record: WorkoutRecord } {
  const upload = calendarWorkoutSchema.parse(input)
  let title: string
  try { title = decodeURIComponent(upload.title).trim() } catch { throw new Error('不支持的训练名称') }
  if (!Object.hasOwn(titles, title)) throw new Error('不支持的训练名称')
  const activity = titles[title]!
  const exported = Date.parse(upload.exportedAt), start = Date.parse(upload.startAt), end = Date.parse(upload.endAt)
  if (exported > now.getTime() + 300_000 || end > exported + 300_000 || start < exported - 30 * 86400_000) throw new Error('训练时间超出范围')
  const record = parseWorkoutInput({ activityType: activity.type, startedAt: upload.startAt,
    timeZone: upload.timeZone, durationMinutes: (end - start) / 60_000, notes: activity.label,
    activeEnergyKcal: upload.activeEnergyKcal }, now)
  // Calendar identity fallback: same activity + start instant. End-time corrections update it.
  record.id = record.externalId = `calendar-workout:${activity.key}:${record.startedAt}`
  record.source = 'shortcuts'
  record.createdAt = record.startedAt
  record.updatedAt = new Date(exported).toISOString()
  return { upload: { ...upload, title: activity.label, startAt: record.startedAt,
    endAt: new Date(end).toISOString(), exportedAt: record.updatedAt }, record }
}
